<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="card shadow my-4">
    <div class="card-body d-flex flex-column">
        <button *ngIf="showCancelButton"
                class="btn text-info btn-link p-0 ml-auto"
                (click)="removeStatement()"
                i18n>Cancel Statement</button>
        <h4 class="font-weight-bold"
            i18n>Select effect</h4>
        <app-radio-select [name]="'effect' + statementIdx"
                          type="inline"
                          [selected]="statement.effect"
                          [options]="effects"
                          (selectOption)="selectEffect($event)"></app-radio-select>

        <h4 class="font-weight-bold"
            i18n>Select service</h4>
        <app-loading-spinner [loadable$]="loadableServices$"></app-loading-spinner>
        <app-error-state [loadable$]="loadableServices$"></app-error-state>
        <app-radio-select [name]="'service' + statementIdx"
                          [selected]="statement.service"
                          [options]="services$ | async"
                          (selectOption)="selectService($event)"></app-radio-select>

        <h4 class="font-weight-bold"
            i18n>Select resource</h4>
        <app-loading-spinner [loadable$]="loadableResourceActions$"></app-loading-spinner>
        <app-error-state [loadable$]="loadableResourceActions$"></app-error-state>
        <p *ngIf="statement.service === undefined"
           class="text-secondary"
           i18n>
            Select a service before applying resources
        </p>
        <app-radio-select [name]="'resource' + statementIdx"
                          *ngIf="resources$ | async"
                          [selected]="statement.resource"
                          [options]="resources$ | async"
                          type="dynamic"
                          classNames="mb-3"
                          (selectOption)="selectResource($event)"></app-radio-select>

        <h4 class="font-weight-bold"
            i18n>Select actions</h4>
        <p *ngIf="statement.resource === undefined"
           class="text-secondary"
           i18n>
            Select a resource before defining actions
        </p>

        <app-loading-spinner [loadable$]="loadableServices$"></app-loading-spinner>
        <app-error-state [loadable$]="loadableServices$"></app-error-state>
        <app-selectable-action-table *ngIf="actions$ | async as actions"
                                     [actions]="actions"
                                     [selected]="statement.actions || []"
                                     (selectActions)="onSelectAction($event)">
        </app-selectable-action-table>

    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/policies/policy-statement-card/policy-statement-card.component.html